import React, { Component } from 'react'

class UserProfile extends Component {
    render() {
        return (
            <div className={this.props.className}>
                <div className="edb-hide-small edb-inline edb-cell-middle edb-lineheight-default edb-right-align">
                    <h6 className="edb-margin-none"><b>{this.props.profile.txScreenName}</b></h6>
                    <div className="edb-small">{this.props.profile.infoShow}</div>
                </div>

                <div className="edb-dropdown-hover">
                    <span className="edb-margin-small-left" dangerouslySetInnerHTML={{ __html: this.props.photo }}></span>

                    <i className="fas fa-sort-down edb-small edb-margin-small-left"></i>
                    <div className="edb-dropdown-content edb-bar-block edb-border" style={{ right: 0 }}>
                        {this.props.profile &&
                            this.props.profile.decodedToken &&
                            this.props.profile.decodedToken.username &&
                            <a
                                href={`https://edu.edebe.com.br/${this.props.profile.decodedToken.username}`}
                                target="_blank"
                                rel='noreferrer noopener'
                                className="edb-bar-item edb-button edb-small">
                                Meu perfil
                            </a>
                        }
                        <button className="edb-bar-item edb-button edb-small" onClick={() => this.props.onLogout()}>Sair</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default UserProfile;